module.exports = __webpack_public_path__ + "img/stock1.9379d669.png";